import { CURRENCY_SYMBOL_LS_TOKEN, UKCurrencies } from './symbols.constants';

export const __symbols = JSON.parse(localStorage.getItem(CURRENCY_SYMBOL_LS_TOKEN)) || {};

/**
 * Singleton Object reading from localStorage value, validity of value resides in symbols.service
 * that expires and update storage and this value as required
 */
const CurrencySymbolStore = {
  set: symbols => Object.assign(__symbols, symbols),
  get: () => __symbols,
  getSymbol: (currency: string): string => __symbols[currency] || '',
};

Object.freeze(CurrencySymbolStore);
export default CurrencySymbolStore;

export const isUKCurrencyCheck = currencyVal => [UKCurrencies.EUR, UKCurrencies.GBP].includes(currencyVal);

export const isUKCurrencyPerSqFtCheck = currencyVal =>
  [
    UKCurrencies.PoundPerSqFt,
    UKCurrencies.EuroPerSqFt,
    UKCurrencies.PoundPerAcre,
    UKCurrencies.EuroPerAcre,
    UKCurrencies.PoundPerHectare,
    UKCurrencies.EuroPerHectare,
    UKCurrencies.EuroPerSQM,
    UKCurrencies.PoundPerSQM,
  ].includes(currencyVal);
